var translate = function (key) {
    if (typeof messages[key] === 'string') {
        return messages[key];
    } else {
        return key;
    }
};

export default translate;



// WEBPACK FOOTER //
// ./app/translate.js